import Service from './Service';
import { isEmpty } from 'lodash';

const resource = '/api/medication-dci';

export default {
    search(search = '', pagination = {}) {
        let url = `${resource}/search?`;
        url += search !== '' ? `s=${encodeURIComponent(search)}` : '';
        url += (!isEmpty(pagination)) ? `&paginate=true&per_page=${pagination.per_page}&page=${pagination.page}` : '';
        return Service.get(url);
    },
    index(search = '', pagination = {}) {
        let url = `${resource}?`;
        url += search !== '' ? `s=${encodeURIComponent(search)}` : '';
        url += (!isEmpty(pagination)) ? `&paginate=true&per_page=${pagination.per_page}&page=${pagination.page}` : '';
        return Service.get(url);
    },
    show(id) {
        return Service.get(`${resource}/show/${id}`);
    }
};
